export {
  hasSignUpExtensionValue,
  isExtensionFieldRequired,
  isSignUpExtensionEditableAfterSignup,
  isSignUpFieldVisible,
} from "@blueskydataplatform/shared-ui/utils/is-extension-field-required";
